export default "__VITE_ASSET__mK5cK4vW__"